import { GraphQlClient, Storage } from '@intelipost-js/secure-providers';

export default {
  getClient() {
    return GraphQlClient.query(`
      query{
        client{
          id
          common_name
          official_name
          weight_unit,
          dimension_unit
        }
      }`)
      .then((res) => {
        const { data = {} } = res || {};
        const { client = {} } = data || {};
        Storage.set('client', client);
        return Promise.resolve(client);
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/client/actions.js